const configuredVersion = Number(process.env.REACT_APP_RECEIPT_UI_VERSION ?? 1);

export const RECEIPT_UI_VERSION = configuredVersion === 2 ? 2 : 1;

